import codes from "./state_code.js"; //状态码，报错提示
import monitor from "./monitor.js";
import user from "./user.js";

export default {
  stateCode: codes,
  ...monitor,
  ...user,
};
